export default {
  language: process.env.NEXT_PUBLIC_LOCALE_LANGUAGE || 'ru'
}
